// AddCredits
import { useAuth } from 'hooks/useAuth';
import { useRouter } from 'next/router';
import React from 'react';
import { getLocalImageUrl } from 'utils/image';
import styles from './AddCredits.module.sass';
import CreditsExplainer from './CreditsExplainer';
import FooterFaqSection from './FooterFAQSection';
import { StripePackage } from 'types/payment';
import CreditsTable from './CreditsTable';

export interface AddCreditsProps {
  creditPackages: StripePackage[];
}

const AddCredits: React.FC<AddCreditsProps> = ({ creditPackages }) => {
  const router = useRouter();
  const handleBack = () => router.back();

  const {
    authState: { brand },
  } = useAuth();

  const showFirstPurchasePromo = typeof brand!.lastPurchaseDate === 'undefined';

  return (
    <div className={styles.addCredits}>
      <div className={styles.header}>
        <button onClick={handleBack} className={styles.backButton}>
          <i className="icon-arrow-backward-filled" />
          <p>Back</p>
        </button>
        <img
          className={styles.logo}
          src={getLocalImageUrl('/images/trend-logo-black.svg')}
          alt="trend logo"
        />
      </div>
      <div className={styles.mobileBanner}>
        <p>Sign in on your computer to review your applications.</p>
      </div>
      <div className={styles.title}>
        <h1>Scaling UGC content is hard. Trend makes it easy.</h1>
      </div>
      {showFirstPurchasePromo && (
        <div className={styles.promoBanner}>
          <p className="VG5000 text-size-regular text-lineheight-xshort text-align-center text-letterspacing-xwide">
            10% off all first time purchases with code: firstcontent10
          </p>
        </div>
      )}
      <CreditsTable creditPackages={creditPackages} />
      <CreditsExplainer />
      <FooterFaqSection />
    </div>
  );
};

export default AddCredits;
